// extracted by mini-css-extract-plugin
module.exports = {"cardUpdateSuccess":"_3Kn93H","title":"_3jtCwo","content":"_1z8q8y","text":"_14FZf_","button":"_20nhWI","textRedirect":"_1wwFcG","shine-lines":"_2dSEhN"};